interface ClipboardTickIconProps {
  color?: string;
  pathOpacity?: number;
  width?: number;
  height?: number;
}

const ClipboardTickIcon = ({
  color = 'currentColor',
  pathOpacity = 0.4,
  width = 24,
  height = 24,
}: ClipboardTickIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity={pathOpacity}
      d="M16.24 3.65039H7.76004C5.29004 3.65039 3.29004 5.66039 3.29004 8.12039V17.5304C3.29004 19.9904 5.30004 22.0004 7.76004 22.0004H16.23C18.7 22.0004 20.7 19.9904 20.7 17.5304V8.12039C20.71 5.65039 18.7 3.65039 16.24 3.65039Z"
      fill={color}
    />
    <path
      d="M14.35 2H9.65001C8.61001 2 7.76001 2.84 7.76001 3.88V4.82C7.76001 5.86 8.60001 6.7 9.64001 6.7H14.35C15.39 6.7 16.23 5.86 16.23 4.82V3.88C16.24 2.84 15.39 2 14.35 2Z"
      fill={color}
    />
    <path
      d="M10.81 16.9496C10.62 16.9496 10.43 16.8796 10.28 16.7296L8.78 15.2296C8.49 14.9396 8.49 14.4596 8.78 14.1696C9.07 13.8796 9.55 13.8796 9.84 14.1696L10.81 15.1396L14.28 11.6696C14.57 11.3796 15.05 11.3796 15.34 11.6696C15.63 11.9596 15.63 12.4396 15.34 12.7296L11.34 16.7296C11.2 16.8796 11 16.9496 10.81 16.9496Z"
      fill={color}
    />
  </svg>
);

export default ClipboardTickIcon;
